import { render } from "./consumoLocal.vue?vue&type=template&id=49a2a29e&scoped=true"
import script from "./consumoLocal.vue?vue&type=script&lang=js"
export * from "./consumoLocal.vue?vue&type=script&lang=js"

import "./consumoLocal.vue?vue&type=style&index=0&id=49a2a29e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a2a29e"]])

export default __exports__